var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{class:_vm.$style.container,attrs:{"id":_vm.id ? `c${_vm.id}` : undefined}},[_vm._t("default"),_c('figcaption',{directives:[{name:"show",rawName:"v-show",value:(_vm.caption !== ''),expression:"caption !== ''"}]},[_vm._v(_vm._s(_vm.caption))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }